export default "__VITE_ASSET__j89tjhhj__"